import { render, staticRenderFns } from "./FormularioOpcaoPage.vue?vue&type=template&id=368b866c"
import script from "./FormularioOpcaoPage.vue?vue&type=script&lang=js"
export * from "./FormularioOpcaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports